<mat-form-field appearance="outline">
  <mat-label>{{label}}</mat-label>
  <mat-select [formControl]="$any(ngControl?.control)">
    @for (item of items; track item) {
    <mat-option [value]="item.value">
      {{item.viewValue}}
    </mat-option>
    }
  </mat-select>
  <mat-icon matSuffix>{{icon}}</mat-icon>
  @if (ngControl?.control?.hasError('required')) {
  <mat-error>
    {{ 'ERROR.PLEASE_ENTER' | transloco }} {{label}}
  </mat-error>
  }
  @if (ngControl?.control?.hasError('touched')) {
  <mat-error>
    {{ 'ERROR.PLEASE_ENTER' | transloco }} {{label}}
  </mat-error>
  }
</mat-form-field>